module.exports = __webpack_public_path__ + "static/Turin-a406c5b750f0ab98e7d498fb83ae783b.jpg";